<section class="flex justify-center items-center">
  <img [src]="images.pax" class="h-6 w-6 mr-1" />
  <label class="text-base font-semibold mr-4">{{ regularSeatsCount }}</label>
  <img [src]="images.prm" class="h-6 w-6 mr-1" />
  <label class="text-base font-semibold mr-4">{{ prmSeatsCount }}</label>
  @if (minorSeatsCount) {
    <img [src]="images.minor" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ minorSeatsCount }}</label>
  }
  @if (petSeatsCount) {
    <img [src]="images.pet" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ petSeatsCount }}</label>
  }
  @if (pregnantSeatsCount) {
    <img [src]="images.pregnant" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ pregnantSeatsCount }}</label>
  }
  @if (dependantSeatsCount) {
    <img [src]="images.dependant" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ dependantSeatsCount }}</label>
  }
  @if (blindSeatsCount) {
    <img [src]="images.blind" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ blindSeatsCount }}</label>
  }
  @if (deafSeatsCount) {
    <img [src]="images.deaf" class="h-6 w-6 mr-1" />
    <label class="text-base font-semibold mr-4">{{ deafSeatsCount }}</label>
  }
</section>
